module.exports = __webpack_public_path__ + "static/media/tabClick.93c93874.mp3";